// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__3JIHy","list":"BalanceDue_list__ZRVEc","listRow":"BalanceDue_listRow__2ggVx","total":"BalanceDue_total__25Cho"};